import { render, staticRenderFns } from "./EmbeddedVideo.vue?vue&type=template&id=e4ebc000&"
import script from "./EmbeddedVideo.vue?vue&type=script&lang=js&"
export * from "./EmbeddedVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports